import React from "react";
import styles from "./index.module.css";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

export default function DrawPrivatepolicy() {
  return (
    <>
      <Header />
      <div className={styles["container-A"]}>
        <div className={styles["container"]}>
          <div className={styles["title"]}>
            <h1>Privacy Policy</h1>
          </div>
          <div className={styles["content"]}>
            <p><span>We respect and value your privacy here at Starnest JSC Company. This Privacy Policy describes the information collected through our mobile application designed for children and how we use that information to provide a safe, educational, and inspiring environment.</span></p>
            <strong><span>1. Information We Collect Automatically</span></strong>
            <p><span>To ensure our drawing tools run smoothly and without graphical errors, we receive certain information automatically when you use our App:</span></p>
            <ul>
                <li>
                    <p>Device &amp; System Information: We collect operating system versions, hardware types, and language settings to ensure technical compatibility and performance.</p>
                </li>
                <li>
                    <p>App Interactions &amp; Analytics: We log how drawing tools are used (e.g., brush selection, features used) to optimize the UI/UX, making it easier and more intuitive for children to navigate.</p>
                </li>
            </ul>
            <strong><span>2. Personal Information &amp; Children&apos;s Privacy (COPPA &amp; GDPR)</span></strong>
            <p><span>We strictly adhere to the Children&rsquo;s Online Privacy Protection Act (COPPA) and General Data Protection Regulation (GDPR):</span></p>
            <ul>
                <li>
                    <p>We do not collect names, precise locations, or contact information from children.</p>
                </li>
                <li>
                    <p>We do not collect Advertising IDs for advertisement tracking in this child-directed app.</p>
                </li>
                <li>
                    <p>Any personal information provided voluntarily (such as a parent&apos;s email for support requests) is used only to respond to that specific request.</p>
                </li>
            </ul>
            <strong><span>3. Parental Rights &amp; Control</span></strong>
            <p><span>In accordance with COPPA, parents and legal guardians have the following rights regarding their child&apos;s information:</span></p>
            <ul>
                <li>
                    <p>Right to Review: You have the right to review the personal information we have collected from your child.</p>
                </li>
                <li>
                    <p>Right to Deletion: You can request that we delete any personal information collected from your child at any time.</p>
                </li>
                <li>
                    <p>Right to Refuse: You may refuse to permit further collection or use of your child&apos;s information.</p>
                </li>
                <li>
                    <p>Procedures for Exercising Rights: To exercise any of these rights, please contact us at&nbsp;<a href="mailto:ngocttbstarnest@gmail.com"><u>ngocttbstarnest@gmail.com</u></a>. We will verify your identity as a parent before granting access or making changes.</p>
                </li>
            </ul>
            <p><br/></p>
            <strong><span>4. Third-Party Services &amp; Partners</span></strong>
            <p><span>4.1. Firebase Services</span></p>
            <p><span>The application uses certain Google Firebase services, including Firebase Analytics and Firebase Crashlytics, to help us understand how the app is used and to improve stability and performance for all users.</span></p>
            <p><span>a. Firebase Analytics</span></p>
            <p><span>We use Firebase Analytics to collect aggregated, non-personal information about how the app is used, such as:</span></p>
            <ul>
                <li>
                    <p>Number of app opens and general usage time</p>
                </li>
                <li>
                    <p>Which screens and features are used most often</p>
                </li>
                <li>
                    <p>Basic device information (device model, operating system version, language settings)</p>
                </li>
            </ul>
            <p><span>This information is used only to analyze usage and improve the user experience, optimize the interface, and enhance features.</span></p>
            <p><span>We do not collect children&rsquo;s names, email addresses, phone numbers, precise locations, or any other directly identifiable personal information through Firebase Analytics.</span></p>
            <p><span>We also do not use Firebase Analytics data for personalized advertising or to track children across apps or websites.</span></p>
            <p><span>b.Firebase Crashlytics</span></p>
            <p><span>We use Firebase Crashlytics to log errors and app crashes. The information collected may include:</span></p>
            <ul>
                <li>
                    <p>The time and frequency of a crash</p>
                </li>
                <li>
                    <p>Technical details about the device and app version</p>
                </li>
                <li>
                    <p>Technical context at the time of the error (such as stack traces and system state)</p>
                </li>
            </ul>
            <p><span>This data is used solely to detect, analyze, and fix technical issues, making the app safer and more stable for users, especially children.</span></p>
            <p><span>Firebase Crashlytics is not used to identify individual children, and we do not attempt to link crash reports with directly identifiable personal information.</span></p>
            <p><span>c. Legal Basis &amp; Child Protection</span></p>
            <p><span>We design the app to be suitable for children and aim to comply with applicable child protection regulations (including COPPA and GDPR-K where applicable).</span></p>
            <p><span>Any data collected through Firebase is used only for:</span></p>
            <ul>
                <li>
                    <p>Aggregated analytics to improve app performance and usability</p>
                </li>
                <li>
                    <p>Error detection and troubleshooting</p>
                </li>
            </ul>
            <p><span>If you are a parent or legal guardian and have questions about how the app &nbsp;uses Firebase services, or if you would like to request deletion of data where possible, please contact us at&nbsp;</span><a href="mailto:ngocttbstarnest@gmail.com"><u>ngocttbstarnest@gmail.com</u></a></p>
            <p><br/></p>
            <p><span>3.2. Google Analytics &nbsp;</span></p>
            <p><span>We use Google Analytics for Firebase to receive anonymous information such as device types and app usage behavior. This help us improve the drawing tools for children. We do not use these tools for advertising or tracking personal information.</span></p>
            <p><span>For more information about Google&rsquo;s practices, please visit:&nbsp;</span><a href="https://www.google.com/policies/privacy/partners/"><span>https://www.google.com/policies/privacy/partners/</span></a></p>
            <strong><span>5. In-App Purchases</span></strong>
            <p><span>When you make in-app purchases, we do not collect or have access to your name or billing information. This information is securely handled by Google Play Store&apos;s payment processor.</span></p>
            <p><br/></p>
            <strong><span>6. How We Use &amp; Share Information</span></strong>
            <p><span>We collect this information solely to improve the performance, reliability, and educational value of our App.</span></p>
            <ul>
                <li>
                    <p>We do not link this information to individuals.</p>
                </li>
                <li>
                    <p>We do not share, sell, or rent your information (including email addresses) to third parties.</p>
                </li>
            </ul>
            <strong><span>7. Changes to This Policy</span></strong>
            <p><span>Starnest JSC Company has the discretion to update this privacy policy at any time. We encourage parents to periodically review this page to stay informed about how we protect their child&apos;s information.</span></p>
            <strong><span>8. Contacting Us</span></strong>
            <p><span>If you have any questions about this Privacy Policy or our practices, please contact us at:&nbsp;</span><a href="mailto:ngocttbstarnest@gmail.com"><u>ngocttbstarnest@gmail.com</u></a></p>
            <p><br/></p>
            <p><br/></p>
            <p><br/></p>
           
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
